import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import { Home, Person, Search } from "@material-ui/icons";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  navigation: {
    backgroundColor: "#fff",
    color: "#000",
    padding: "10px 36px",
    display: "flex",
    justifyContent: "space-between",
    position: "fixed",
    bottom: 0,
    left: "50%",
    transform: "translate(-50%, 0)",
    width: "345px",
    zIndex: "8",
    [theme.breakpoints.down("360")]: {
      width: "280px",
    },
    "& a": {
      color: "#B9BACC",
      position: "relative",
      "&:before": {
        position: "absolute",
        content: '""',
        width: "5px",
        height: "5px",
        borderRadius: "50%",
        background: "#2530B8",
        transform: "scale(0)",
        transition: "0.3s",
        bottom: "5px",
        right: "9px",
      },
    },
    "& a.active": {
      color: "#2530B8",
      "&:before": {
        transform: "scale(1)",
      },
    },
  },
}));

export default function Navigation() {
  const classes = useStyles();
  const [activeMenu, setActiveMenu] = useState("dashboard");

  return (
    <Box className={classes.navigation}>
      <Link
        to="/"
        className={activeMenu === "dashboard" && "active"}
        onClick={() => {
          setActiveMenu("dashboard");
        }}
      >
        <Home />
      </Link>
      <Link
        to="/profile"
        className={activeMenu === "profile" && "active"}
        onClick={() => {
          setActiveMenu("profile");
        }}
      >
        <Person />
      </Link>
      <Link
        to="/search"
        className={activeMenu === "search" && "active"}
        onClick={() => {
          setActiveMenu("search");
        }}
      >
        <Search />
      </Link>
    </Box>
  );
}
